<template>
  <div>
    <topQuantity style="margin-bottom: 20px;" />
    <div class="components-row">
      <leftPipeDiameter />
      <middleRemote />
      <rightValve />
    </div>
  </div>
</template>



<script>
import topQuantity from './workBanchModule/TopQuantity.vue'
import leftPipeDiameter from './workBanchModule/LeftPipeDiameter.vue'
import middleRemote from './workBanchModule/MiddleRemote.vue'
import rightValve from './workBanchModule/RightValve.vue'
export default {
  name: 'workBench',
  components: {
    topQuantity,
    leftPipeDiameter,
    middleRemote,
    rightValve
  },
  created() {
    this.setSystemName()
  },
  methods: {
    setSystemName() {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}管网GIS系统`)
    }
  }
};

</script>

<style lang="less" scoped>
.components-row {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
</style>